import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-member-site-changed-dialog',
  templateUrl: './member-site-changed-dialog.component.html',
  styleUrls: [ './member-site-changed-dialog.component.scss' ]
})
export class MemberSiteChangedDialogComponent implements OnInit {

  public dataChanged: any;

  constructor (
    public matDialogRef: MatDialogRef<MemberSiteChangedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dataChanged = this.data
    console.log(JSON.stringify(this.dataChanged))
    console.log(": " + JSON.stringify(this.dataChanged))
  }

  ngOnInit () {}



}
